import React from "react";
import { motion } from "framer-motion";
import { ArrowDownIcon } from "lucide-react";
import { images } from "../../data/images";
import { IngredientFinder } from "./IngredientFinder";
import { scrollToId } from "../../utils/scroll";
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="relative isolate flex min-h-[100svh] w-full items-end overflow-hidden bg-ink" data-id="element-103" data-mp="ep3vk0242ik7">
      <img src={images.hero} alt="Champs de lavande et mas en pierre du Domaine de la Rouquette au lever du soleil" className="absolute inset-0 -z-10 h-full w-full object-cover" data-id="element-104" data-mp="apbhj7ty7k7g" />
      <div className="absolute inset-0 -z-10 bg-ink/45" aria-hidden data-id="element-105" data-mp="qw1bzwglvcq" />

      <div className="mx-auto grid w-full max-w-[1400px] gap-10 px-5 pb-12 pt-32 md:px-10 md:pb-16 lg:grid-cols-12 lg:items-end" data-id="element-106" data-mp="3rxgo37fheh3y">
        <motion.div className="lg:col-span-7" initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-107" data-mp="1v3vc9fpwa1do">
          <h1 className="font-display text-[3.2rem] font-normal leading-[0.95] tracking-tight text-paper sm:text-7xl xl:text-[6.5rem]" data-id="element-108" data-mp="1murhkmutk22x">
            Le végétal de Provence,
            <br data-id="element-109" data-mp="1cyy9bfo4uuqy" />
            <em className="font-normal" data-id="element-110" data-mp="1czga8plqpx57">prêt pour vos formules.</em>
          </h1>
          <p className="mt-7 max-w-xl text-base leading-relaxed text-paper/85 md:text-lg" data-id="element-111" data-mp="1hwga2irzy3nv">
            Huiles essentielles, hydrolats, huiles végétales et extraits cultivés et distillés au domaine.
            Lots tracés, dossier réglementaire complet, réponse aux devis sous 48 h.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-3" data-id="element-112" data-mp="1vxslqi04jj3y">
            <button type="button" onClick={() => scrollToId("devis")} className="h-12 whitespace-nowrap rounded-full bg-terracotta px-7 text-sm font-medium text-paper transition-colors duration-150 ease-out hover:bg-terracotta-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-paper focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-113" data-mp="20w3vytubzvmp">
              Demander un devis
            </button>
            <button type="button" onClick={() => scrollToId("ingredients")} className="flex h-12 items-center gap-2 whitespace-nowrap rounded-full border border-paper/40 px-6 text-sm text-paper transition-colors duration-150 ease-out hover:bg-paper/10" data-id="element-114" data-mp="2ya3hozjd5xen">
              Explorer les ingrédients <ArrowDownIcon className="h-4 w-4" data-id="element-115" data-mp="2fisr6jhjvmna" />
            </button>
          </div>
        </motion.div>

        <motion.div className="lg:col-span-5 lg:pl-6 xl:col-span-4 xl:col-start-9" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease
      }} data-id="element-116" data-mp="2ajg6a4a8opnc">
          <IngredientFinder data-id="element-117" data-mp="21ii3tqfg8q6v" />
        </motion.div>
      </div>
    </section>;
}